function track_msdynmkt_apg_go2easy_loggedin_094427574(step: string, email: string) {
  window['msdynmkt'].setUser({ authId: email }); // ID, e-mail or phone number - see instructions
  window['msdynmkt'].trackEvent({
    name: 'msdynmkt_apg_go2easy_loggedin_094427574', //Trigger title: APG - Go2Easy - LoggedIn
    ingestionKey: '5aed88c316cd4dbfb931d6b36a0bbe94-eb09328a-291c-4c25-a763-96971e4a5f23-7074',
    version: '1.0.0',
    properties: {
      bindingid: 'step',
      parametertext: `step-${step}`,
    },
  });
}

function track_msdynmkt_apg_kuzu3_decisionphase_online_093516022(step: string, email: string) {
  window['msdynmkt'].setUser({ authId: email }); // ID, e-mail or phone number - see instructions
  window['msdynmkt'].trackEvent({
    name: 'msdynmkt_apg_kuzu3_decisionphase_online_093516022', //Trigger title: APG - Kuzu 3 - Decision Phase - Online
    ingestionKey: '5aed88c316cd4dbfb931d6b36a0bbe94-eb09328a-291c-4c25-a763-96971e4a5f23-7074',
    version: '1.0.0',
    properties: {
      bindingid: 'step',
      parametertext: `step-${step}`,
    },
  });
}

function track_msdynmkt_apg_go2easy_purchase_094606892(step: string, email: string) {
  window['msdynmkt'].setUser({ authId: email }); // ID, e-mail or phone number - see instructions
  window['msdynmkt'].trackEvent({
    name: 'msdynmkt_apg_go2easy_purchase_094606892', //Trigger title: APG - Go2Easy - Purchase
    ingestionKey: '5aed88c316cd4dbfb931d6b36a0bbe94-eb09328a-291c-4c25-a763-96971e4a5f23-7074',
    version: '1.0.0',
    properties: {
      bindingid: 'step',
      parametertext: `step-${step}`,
    },
  });
}

function track_msdynmkt_apg_kuzu3_purchasephase_online_094720844(step: string, email: string) {
  window['msdynmkt'].setUser({ authId: email }); // ID, e-mail or phone number - see instructions
  window['msdynmkt'].trackEvent({
    name: 'msdynmkt_apg_kuzu3_purchasephase_online_094720844', //Trigger title: APG - Kuzu 3 - Purchase Phase - Online
    ingestionKey: '5aed88c316cd4dbfb931d6b36a0bbe94-eb09328a-291c-4c25-a763-96971e4a5f23-7074',
    version: '1.0.0',
    properties: {
      bindingid: 'step',
      parametertext: `step-${step}`,
    },
  });
}

export const triggerDynamicsOnLoginArea = (step: string, email: string) => {
  try {
    track_msdynmkt_apg_kuzu3_decisionphase_online_093516022(step, email);
    track_msdynmkt_apg_go2easy_loggedin_094427574(step, email);
  } catch (error) {
    console.log('Error tracking dynamics', error);
  }
};

export const triggerDynamicsOnFinishOrder = (step: string, email: string) => {
  try {
    track_msdynmkt_apg_go2easy_purchase_094606892(step, email);
    track_msdynmkt_apg_kuzu3_purchasephase_online_094720844(step, email);
  } catch (error) {
    console.log('Error tracking dynamics', error);
  }
};
